<template>
  <div class="page-upload-image xc-modal xc-modal-page">
    <div class="xc-modal-wrap">
      <div class="xc-modal-content">
        <div class="xc-modal-header">
          <div class="xc-modal-title">本地上传图片</div>
          <div class="xc-modal-close" @click="layerClose"></div>
        </div>
        <div
          class="xc-modal-body"
          v-loading="loading"
          element-loading-text="上传中，请稍后..."
        >
          <div v-if="channel == '0'">
            <form class="form">
              <xc-form-item
                label="播放时长(秒)"
                class="xc-form-item-fixed"
                :error="errors.first('duration')"
                required
              >
                <input
                  name="duration"
                  v-model="data.duration"
                  type="text"
                  class="xc-input"
                  v-validate="'required|min_value:1|max_value:999999'"
                  data-vv-as="播放时长"
                  placeholder="请输入秒数"
                />
              </xc-form-item>
              <xc-form-item
                label="图片"
                style="align-items: inherit"
                required
                class="position-upload"
              >
                <xc-upload1
                  :fileList.sync="data.files"
                  type="1"
                  :multiple="true"
                  accept="image/*"
                  :url="uploadUrl"
                  :beforeUpload="beforeUpload"
                />
                <input
                  type="file"
                  class="file-input"
                  id="file-selector"
                  accept="image/*"
                  size="small"
                  @change="changeFile"
                />
              </xc-form-item>
            </form>
          </div>
          <div v-if="channel == '1'">
            <form class="form">
              <xc-form-item
                label="选择分组"
                class="xc-form-item-fixed"
                required=""
                :error="errors.first('groupId')"
              >
                <select
                  name="groupId"
                  class="xc-select"
                  v-validate="'required'"
                  data-vv-as="分组"
                  v-model="fileGroupId"
                >
                  <option value="">请选择</option>
                  <template v-if="fileGroups.length">
                    <option
                      v-for="(item, index) in fileGroups"
                      :key="index"
                      :value="item.fileGroupId"
                    >
                      {{ item.fileGroupName }}
                    </option>
                  </template>
                </select>
              </xc-form-item>
              <xc-form-item
                class="position-upload"
                label="图片"
                style="align-items: inherit"
                required
              >
                <xc-upload1
                  :fileList.sync="data.files"
                  type="1"
                  :multiple="true"
                  accept="image/*"
                  :url="uploadUrl"
                  :beforeUpload="beforeUpload"
                  @del="del"
                />
                <input
                  type="file"
                  class="file-input"
                  id="file-selector"
                  accept="image/*"
                  size="small"
                  @change="changeFile"
                />
              </xc-form-item>
            </form>
          </div>
        </div>
        <div class="xc-modal-footer xc-flex-center">
          <div class="xc-btn-group">
            <div class="xc-btn xc-btn-default" @click="layerClose">取消</div>
            <div class="xc-btn xc-btn-primary" @click.prevent="submit">
              确定
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/libs/vee-validate";
import material from "@/api/material";
// import { mapState, mapActions } from "vuex";
import sysconfigApi from "@/api/sysconfig";
import { uploadFile } from "@/utils/uploadfile";

export default {
  name: "materialUploadImage",
  data() {
    return {
      // 来源渠道 0、节目编辑器（图片上传） 1、素材库（图片上传）
      channel: this.$route.query.channel || 0,
      fileGroups: [], // 素材分组
      fileGroupId: this.$route.query.fileGroupId || "", // 当前分组ID
      data: {
        duration: 15,
        files: [],
      },
      uploadUrl: "",

      // 系统配置
      sysConfig: {},
      loading: false,
    };
  },
  mounted() {},
  created() {
    if (this.channel == 1) {
      // 获取素材分组
      material.getFileGroup().then((success) => {
        this.fileGroups = success.data;
      });
    }

    // 获取系统设置
    sysconfigApi.getConfig().then((ret) => {
      const sysConfig = {};
      ret.data.map((item) => {
        sysConfig[item.type] = item;
      });

      this.sysConfig = sysConfig;
    });
  },
  methods: {
    changeFile(event) {
      let file = event.target.files[0];
      console.log(file, "filefile");
      if (!file) return;
      this.loading = true;
      this.cosUploadFile(file);
    },
    // 通过腾讯云 cos-js-sdk-v5 上传
    cosUploadFile(file) {
      uploadFile(file, (err, data) => {
        if (err) {
          console.log(err);
        } else {
          let fileData = JSON.parse(JSON.stringify(data));
          fileData.url = data.fid;
          fileData.file = data.fid;
          fileData.fileImageUrl = data.fid;
          fileData.md5 = file.md5;
          fileData.type = file.type;
          fileData.name = file.name;
          fileData.size = file.size;
          fileData.fileType = "image";
          fileData.fileSuffix = file.name.split(".")[1];
          fileData.fileName = file.name.split(".")[0];
          fileData.status = "success";
          this.data.files.push(fileData);
          this.loading = false;
        }
      });
    },
    del() {
      document.getElementById("file-selector").value = "";
    },
    layerClose() {
      var index = parent.layer.getFrameIndex(window.name);
      parent.layer.close(index);
    },
    submit() {
      console.log("确定");
      this.$validator.validateAll().then((validate) => {
        if (validate) {
          if (!this.data.files || this.data.files.length == 0) {
            return this.$message.error("请上传图片");
          }

          const file = this.data.files[0];
          if (!file.url) {
            return this.$message.error("请上传图片");
          }

          const returnData = this.data.files.map((file) => {
            return {
              duration: Number(this.data.duration * 1000),
              fileSuffix: file.fileSuffix,
              url: file.url,
              fileName: file.fileName,
              md5: file.md5,
              size: file.size,
              fileType: "image",
            };
          });

          const confirmData = this.data.files.map((file) => {
            return {
              ...file,
              fileType: "image",
              groupId: this.fileGroupId,
            };
          });

          // 将素材入库
          material
            .uploadSure({
              files: JSON.stringify(confirmData),
            })
            .then(() => {
              parent.window.imageUploadSubmit(returnData);
              this.layerClose();
            });
        } else {
          let error = this.errors.items[0].msg;
          this.$message.error(error);
        }
      });
    },

    beforeUpload(file) {
      if (!this.sysConfig.upload_max_picture_size) {
        this.$message.error("上传配置获取识别，请稍后重试");
        return false;
      }

      const maxSize =
        this.sysConfig.upload_max_picture_size.value * 1024 * 1024;
      const passSuffix = this.sysConfig.pass_picture_suffix.value.split(",");
      if (file.size > maxSize) {
        this.$message.error(
          "图片大小不能超过" +
            this.sysConfig.upload_max_picture_size.value +
            "MB"
        );
        return false;
      }

      const suffixAry = file.name.split(".");
      console.log(
        suffixAry,
        "suffixAry",
        passSuffix,
        passSuffix.indexOf(suffixAry)
      );
      if (suffixAry.length == 0) {
        // if (passSuffix.indexOf(suffixAry) === -1) {
        console.log("文件格式不正确，请上传");
        this.$message.error(
          "文件格式不正确，请上传" + passSuffix.join(",") + "格式文件"
        );
        return false;
      }

      // 判断是否允许的格式
      const allowType = passSuffix.some((item) => {
        return suffixAry[suffixAry.length - 1] == item;
      });

      console.log(allowType, "allowType");

      // 不允许的文件格式
      if (!allowType) {
        console.log("文件格式不正确，请上传");
        this.$message(
          "文件格式不正确，请上传" + passSuffix.join(",") + "格式文件"
        );
        return false;
      }
    },
  },
  computed: {
    // ...mapState(["globalConfig"]),
  },
};
</script>

<style lang="scss">
.page-upload-image {
  .xc-form-item-label {
    min-width: 90px;
  }
}
.position-upload {
  position: relative;
}
.file-input {
  position: absolute;
  top: 0;
  min-height: 40px;
  opacity: 0;
}
</style>
